<template>
    <b-col md="12" sm="8" style="padding: 5px 5px 5px 5px">
      <b-card no-body class="mx-4">
          <b-card-header header-bg-variant="primary" header-text-variant="white">
              <h1 class="titulo"><span class="bold">Formulário {{questionario.titulo}}</span></h1>
          </b-card-header>
          <b-card-body class="p-4">
              <b-form v-on:submit.prevent="onSubmit">
                  <b-row>
                      <b-col class="col-md-6 col-sm-12">
                          <span v-if="!visualizar" class="text-danger"><span class="bold">*</span> Preenchimento Obrigatório</span>
                      </b-col>
                      <b-col class="col-md-6 col-sm-12 sistema-nome">
                          <h5>Sistema <span class="bold">{{sistema.nome}}</span></h5>
                      </b-col>
                  </b-row>
                  <hr>
                  <b-row v-if="questionario.solicitar_responsavel">
                      <b-col class="col-md-8 col-sm-12">
                          <b-form-group>
                            <template slot="label">Responsavél pelo preenchimento <span class="bold text-danger">*</span></template>
                              <b-input-group class="mb-3">
                                  <b-form-input
                                    v-model="$v.responsavel.$model"
                                    :disabled="visualizar || visualizarQuestionario"
                                    :state="chkState('responsavel')"
                                    type="text"
                                    class="form-control"
                                    placeholder="" />
                                  <b-form-invalid-feedback id="input1LiveFeedback3">Responsável pelo preenchimento é um campo obrigatório.</b-form-invalid-feedback>
                              </b-input-group>
                          </b-form-group>
                      </b-col>
                  </b-row>
                  <b-row v-if="questionario.solicitar_nome_org">
                      <b-col class="col-md-8 col-sm-12">
                          <b-form-group>
                            <template slot="label">Nome da Organização <span class="bold text-danger">*</span></template>
                              <b-input-group class="mb-3">
                                  <b-form-input
                                    v-model="$v.responsavelOrganizacao.$model"
                                    :disabled="visualizar || visualizarQuestionario"
                                    :state="chkState('responsavelOrganizacao')"
                                    type="text"
                                    class="form-control"
                                    placeholder="" />
                                  <b-form-invalid-feedback id="input1LiveFeedback3">Nome da Organização é um campo obrigatório.</b-form-invalid-feedback>
                              </b-input-group>
                          </b-form-group>
                      </b-col>
                  </b-row>
                  <b-row v-if="questionario.solicitar_cpf_responsavel">
                      <b-col class="col-md-8 col-sm-12">
                          <b-form-group>
                            <template slot="label">CPF do Responsavél pelo preenchimento <span class="bold text-danger">*</span></template>
                              <b-input-group class="mb-3">
                                  <b-form-input
                                    v-model.trim="$v.responsavelCpf.$model"
                                    :disabled="visualizar || visualizarQuestionario"
                                    :state="chkStateCPF()"
                                    type="text"
                                    v-mask="'###.###.###-##'"
                                    class="form-control"
                                    placeholder="" />
                                  <b-form-invalid-feedback
                                    v-if="$v.responsavelCpf.$model.length < 14 || $v.responsavelCpf.$model.length > 14"
                                    id="input1LiveFeedback3"
                                  >CPF inválido.</b-form-invalid-feedback>
                                  <b-form-invalid-feedback
                                    v-else id="input1LiveFeedback3"
                                  >CPF do Responsável pelo preenchimento é um campo obrigatório.</b-form-invalid-feedback>
                              </b-input-group>
                          </b-form-group>
                      </b-col>
                  </b-row>
                  <b-row v-if="questionario.solicitar_localizacao && !visualizar">
                      <b-col class="col-md-12 col-sm-12">
                          <b-form-group>
                              <b-form-checkbox
                                id="localizacao"
                                :disabled="visualizar || visualizarQuestionario"
                                v-model="localizacao"
                                name="localizacao"
                                value="aceito"
                                unchecked-value="nao_aceito"
                              >
                                <span class="bold">Aceito informar a localização de onde estou preenchendo o formulário.</span>
                              </b-form-checkbox>
                          </b-form-group>
                      </b-col>
                  </b-row>
                  <b-row v-if="questionario.solicitar_localizacao && visualizar && resposta.lat != null">
                      <b-col sm="12" md="12">
                        <label>Localização do Preenchimento do Formulário</label>
                      </b-col>
                      <b-col sm="12" md="12" style="height: 500px; margin-bottom: 25px; width: 80%" v-if="coordenadas.lat">
                          <template>
                            <div id="map" ref="myMap"></div>
                          </template>
                      </b-col>
                      <b-col sm="12" md="6">
                        <b-form-group label-cols="3" label="Latitude:">
                            <b-input-group class="mb-3">
                                <b-form-input
                                  v-model="coordenadas.lat"
                                  :disabled="true"
                                  type="text"/>
                            </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12" md="6">
                        <b-form-group label-cols="3" label="Longitude:">
                            <b-input-group class="mb-3">
                                <b-form-input
                                  v-model="coordenadas.lon"
                                  :disabled="true"
                                  type="text" />
                            </b-input-group>
                        </b-form-group>
                      </b-col>
                  </b-row>
                  <b-row v-if="questionario.descricao">
                    <b-col class="col-md-12 col-sm-12">
                      <b-card-header class="titulo secao-head">
                        <label>Descrição</label>
                      </b-card-header>
                      <b-card-body>
                        <span v-html="questionario.descricao" style="font-size: 14px"/>
                      </b-card-body>
                    </b-col>
                  </b-row>
                  <b-row v-for="(linha, i) in secoesQuestionario" :key="i">
                      <b-col class="col-md-12 col-sm-12">
                          <b-card-header class="titulo secao-head">
                              <label>{{linha.titulo}}</label>
                          </b-card-header>
                          <b-card-body>
                              <div v-for="(pergunta, j) in linha.pergunta" :key="j">
                                  <pergunta-responder
                                    :perguntaResponder="pergunta"
                                    :secao="linha"
                                    @getUM.once="getUM"
                                    :salvarForm="salvarForm"
                                    :disabled="visualizar || visualizarQuestionario"
                                    :visualizarQuestionario="visualizarQuestionario"
                                    :configCpf="configCpf"
                                    :configCnpj="configCnpj"
                                    :camposConfiguracaoCpf="camposConfiguracaoCpf"
                                    :camposConfiguracaoCnpj="camposConfiguracaoCnpj"
                                    @finalizarQuestionario="finalizarQuestionario"
                                    :diretorio="diretorio"
                                  ></pergunta-responder>
                              </div>
                          </b-card-body>
                      </b-col>
                  </b-row>
              </b-form>
          </b-card-body>
          <b-card-footer class="p-12">
              <b-row>
                  <b-col v-if="!loading && !visualizar && !visualizarQuestionario" class="col-md-3 col-sm-12">
                      <b-button block variant="primary" v-on:click="onSubmit">
                          <i class="fa fa-plus"></i>&nbsp;
                          <span>Enviar</span>
                      </b-button>
                  </b-col>
                  <b-col v-if="loading && !visualizar && !visualizarQuestionario" class="col-md-3 col-sm-12">
                      <b-button block variant="primary" :disabled="true">
                          <b-spinner small type="grow"></b-spinner>Salvando...
                      </b-button>
                  </b-col>
                  <b-col md="3" v-if="(visualizar || visualizarQuestionario) && visualizarBotaoVoltar">
                    <b-button block variant="secondary" @click="voltar()">
                      <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
                    </b-button>
                  </b-col>
              </b-row>
          </b-card-footer>
      </b-card>
    </b-col>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import perguntaResponder from '@/components/questionarios/ResponderPergunta'
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import SessionStorage from '@/services/session-storage'
import _ from 'lodash'

miniToastr.init()

export default {
  name: 'ResponderQuestionario',
  components: {
    perguntaResponder
  },
  mixins: [validationMixin],
  validations: {
    responsavel: {
      required: requiredIf(function (data) {
        return !data.responsavel && data.questionario.solicitar_responsavel
      })
    },
    responsavelCpf: {
      required: requiredIf(function (data) {
        return !data.responsavelCpf && data.questionario.solicitar_cpf_responsavel
      })
    },
    responsavelOrganizacao: {
      required: requiredIf(function (data) {
        return !data.responsavelOrganizacao && data.questionario.solicitar_nome_org
      })
    }
  },
  created () {
    let usuario = SessionStorage.get('usuario')
    if (usuario) {
      this.buscaUsuarioIntegracao(usuario)

      if (!usuario) {
        this.$router.push('/login')
      }
      this.$store.dispatch('atualizarPermissoes')
    }

    if (this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')) {
      if (this.$route.params.token) {
        var data = {id: this.$route.params.id, token: this.$route.params.token}
        this.$store.dispatch('getRespostaToken', data)
      } else {
        this.$store.dispatch('getResposta', this.$route.params.id)
      }
    } else if (this.$route.matched.some(({ name }) => name == 'Visualizar Formulário')) {
      if (!this.can('questionario.show')) {
        this.$router.push('/')
      }

      this.$store.dispatch('getQuestionario', this.$route.params.id)
    } else {
      this.$store.dispatch('getQuestionarioResponder', this.$route.params.token)
    }
  },
  mounted () {
    const agora = new Date()
    this.diretorio = agora.getFullYear().toString() + agora.getMonth().toString() + agora.getDay().toString() + agora.getHours().toString() +
      agora.getMinutes().toString() + agora.getSeconds().toString() + agora.getMilliseconds().toString()
  },
  beforeUpdate () {
    this.getSistema()
  },
  data () {
    return {
      envioRespondido: [],
      questionarioRespondido: [],
      secoesQuestionario: null,
      responsavel: '',
      responsavelCpf: '',
      responsavelOrganizacao: '',
      localizacao: null,
      salvarForm: false,
      usuarioIntegracao: [],
      sistemaIntegracao: [],
      camposConfiguracaoCpf: [],
      camposConfiguracaoCnpj: [],
      configCpf: false,
      configCnpj: false,
      loading: false,
      reenviado: false,
      coordenadas: {lat: '', lon: ''},
      endereco: null,
      diretorio: null,
      visualizarBotaoVoltar: true,
      evtFired: 0
    }
  },
  computed: {
    ...mapState({
      carregando: state => state.resposta.carregando
    }),
    questionario () {
      if (this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')) {
        return this.questionarioRespondido
      } else if (this.$route.matched.some(({ name }) => name == 'Visualizar Formulário')) {
        return this.$store.state.questionario.questionarioEditar
      } else {
        return this.$store.state.questionario.questionarioResponder
      }
    },
    status () {
      if (!this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')) {
        return this.$store.state.questionario.status
      }
    },
    envio () {
      if (this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')) {
        return this.envioRespondido
      } else {
        return this.$store.state.questionario.envio
      }
    },
    reenvio () {
      return this.reenviado
    },
    sistema () {
      return this.$store.state.sistema.sistemaEditar
    },
    resposta () {
      if (this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')) {
        return this.$store.state.resposta.resposta
      } else {
        return this.$store.state.questionario.respostas
      }
    },
    visualizar () {
      return this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')
    },
    visualizarQuestionario () {
      return this.$route.matched.some(({ name }) => name == 'Visualizar Formulário')
    },
    visualizarResposta () {
      return this.$route.params.external != undefined
    },
    isValid () {
      return !this.$v.$anyError
    }
  },
  watch: {
    'status': function () {
      if (!this.visualizar) {
        if (this.status == 'respondido') {
          this.$store.dispatch('setMensagemQuestionario', 'Você já respondeu este formulário!', 'respondido')
          this.$router.push('/mensagem')
        }

        if (this.status == 'suspenso') {
          this.$store.dispatch('setMensagemQuestionario', 'Este formulário não está mais disponível para preenchimento!', 'suspenso')
          this.$router.push('/mensagem')
        }

        if (this.status == 'reenviado') {
          this.reenviado = true
        }

        this.setDados()
      }
    },
    'resposta': function () {
      if (this.$route.matched.some(({ name }) => name == 'Visualizar Resposta')) {
        this.questionarioRespondido = this.resposta.envio.questionario
        this.envioRespondido = this.resposta.envio
        this.setDados()
      }
    },
    'questionario': function () {
      if (this.$route.matched.some(({ name }) => name == 'Visualizar Formulário')) {
        this.setDados()
      }
    },
    'localizacao': function () {
      if (!this.visualizar && !this.visualizarQuestionario) {
        if (this.localizacao == 'aceito') {
          navigator.geolocation.getCurrentPosition(
            position => {
              this.buscaEndereco(position.coords.latitude, position.coords.longitude)
            },
            error => {
              console.log(error.message)
            }
          )
        }
      }
    },
    'coordenadas.lat': function () {
      if (document.getElementById('scriptBingMaps')) {
        return
      }

      window.OnLoadBingMapsApi = () => this.InitMap()

      var scriptTag = document.createElement('script')
      scriptTag.src = 'https://www.bing.com/api/maps/mapcontrol?callback=OnLoadBingMapsApi&key=ApMnkKVfeR6IMB7Sq7CfZ4r6FVcwj46qVUJL9pGLcvapPmS2vTQd9yR33UDOw92n'
      scriptTag.id = 'scriptBingMaps'

      document.head.appendChild(scriptTag)
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    InitMap: function () {
      var mapElement = this.$refs.myMap

      // eslint-disable-next-line no-undef
      this.map = new Microsoft.Maps.Map(mapElement, {
      // eslint-disable-next-line no-undef
        mapTypeId: Microsoft.Maps.MapTypeId.grayscale,
        zoom: 15,
        maxZoom: 21,
        disableScrollWheelZoom: true,
        showMapTypeSelector: false,
        // eslint-disable-next-line no-undef
        center: new Microsoft.Maps.Location(this.coordenadas.lat, this.coordenadas.lon),
        maxNetworkLinkDepth: 3
      })

      var center = this.map.getCenter()

      // eslint-disable-next-line no-undef
      var pin = new Microsoft.Maps.Pushpin(center, {
        title: 'Localização do responsável',
        icon: require('@/assets/bmv8-poi-custom.png'),
        // eslint-disable-next-line no-undef
        anchor: new Microsoft.Maps.Point(12, 39)
      })

      this.map.entities.push(pin)
    },
    async buscaEndereco (lat, lon) {
      this.coordenadas.lat = lat
      this.coordenadas.lon = lon

      var { data } = await axios.get(
        'https://dev.virtualearth.net/REST/v1/Locations/' +
            lat +
            ', ' +
            lon +
            '?includeEntityTypes=&key=ApMnkKVfeR6IMB7Sq7CfZ4r6FVcwj46qVUJL9pGLcvapPmS2vTQd9yR33UDOw92n'
      )

      if (data.statusCode == 200) {
        this.endereco = data.resourceSets[0].resources[0].address.locality +
            ', ' + data.resourceSets[0].resources[0].address.adminDistrict +
            ', ' + data.resourceSets[0].resources[0].address.countryRegion
      }
    },
    getSistema () {
      if (this.questionario.sistema_cliente_id != undefined && this.sistema.length < 1) {
        this.$store.dispatch('getSistema', this.questionario.sistema_cliente_id)
      }
    },
    setDados () {
      let secoes = []

      if (this.visualizar || this.reenviado) {
        this.responsavel = this.resposta.nome_responsavel
        this.responsavelCpf = this.resposta.cpf_responsavel
        this.responsavelOrganizacao = this.resposta.nome_organizacao
        this.localizacao = !this.resposta.endereco && !this.resposta.lat && !this.resposta.lon ? 'nao_aceito' : 'aceito'
        this.coordenadas.lat = this.resposta.lat
        this.coordenadas.lon = this.resposta.lon
      }

      if (this.questionario.secoes) {
        this.questionario.secoes.forEach((element) => {
          // cria a secao
          secoes.push({
            titulo: element.titulo,
            ordem: element.ordem,
            pergunta: []
          })

          let numero = 0

          // percorre as perguntas da seção
          element.pergunta.forEach((element) => {
            numero += 1
            // chama o metodo que seta as perguntas e retroativamente suas opções e dependentes
            this.setPergunta(element, secoes[(secoes.length - 1)].pergunta, numero)
          })
        })
      }

      this.secoesQuestionario = secoes
      this.verificaConfiguracao()
    },
    verificaConfiguracao () {
      if (this.questionario.configura_cpf) {
        this.configCpf = true
        Vue.http.get('api/questionario/getConfigCpf/' + this.questionario.id).then(response => {
          this.camposConfiguracaoCpf = response.data.data[0]
        })
      }
      if (this.questionario.configura_cnpj) {
        this.configCnpj = true
        Vue.http.get('api/questionario/getConfigCnpj/' + this.questionario.id).then(response => {
          this.camposConfiguracaoCnpj = response.data.data[0]
        })
      }
    },
    setPergunta (pergunta, array, numero, dependente = false, posicaoPai = null, numeroPai = '', opcaoDependente = null) {
      let posicao = 0

      //  prepara as variaveis para receberem respostas
      let respostaOpRespondida = null
      let respostaTextoRespondida = null
      let respostaUfRespondida = null
      let respostaCidadeRespondida = null
      let respostaUploadRespondida = []
      let exibe = !dependente

      //  se for visualização de resposta ou reenvio do questionario seta as respostas
      if (this.visualizar || this.reenviado) {
        this.resposta.perguntas_respostas.forEach((element) => {
          if (pergunta.id == element.pergunta_id) {
            if (element.alternativa_id != null) {
              respostaOpRespondida = element.alternativa_id
            }

            if (element.alternativas_respondidas.length > 0) {
              respostaOpRespondida = []
              element.alternativas_respondidas.forEach((item) => {
                respostaOpRespondida.push(item.alternativa_id)
              })
            }

            if (element.arquivos.length > 0) {
              element.arquivos.forEach(file => {
                respostaUploadRespondida.push({
                  nome: file.resposta_upload.substring(file.resposta_upload.indexOf('documentos/') + 11),
                  data: file.resposta_upload
                })
              })
            }

            respostaTextoRespondida = element.resposta_texto
            respostaUfRespondida = element.uf_id
            respostaCidadeRespondida = element.cidade_id
            exibe = true
          }
        })
      }

      //  se for visualização do formulário em si libera a exibição de todas as perguntas
      if (this.visualizarQuestionario) {
        exibe = true
      }

      //  seta os dados para o array das perguntas
      let numeroAtual = dependente ? numeroPai + '.' + numero : numero
      array.push({
        numero: numeroAtual,
        id: pergunta.id,
        titulo: pergunta.titulo,
        ordem: pergunta.ordem,
        hint: pergunta.hint,
        tipo: pergunta.tipo,
        size: pergunta.size,
        dependente: dependente,
        posicaoPai: posicaoPai,
        opcaoDependente: opcaoDependente,
        exibe: exibe,
        required: pergunta.required,
        finaliza_questionario: pergunta.finaliza_questionario,
        disabled: false,
        opcoes: [],
        resposta: {
          respostaOp: respostaOpRespondida,
          respostaTexto: respostaTextoRespondida,
          uf_id: respostaUfRespondida,
          cidade_id: respostaCidadeRespondida,
          perguntaId: pergunta.id,
          respostaUpload: respostaUploadRespondida
        }
      })

      //  posição do registro inserido
      posicao = array.length - 1

      //  numero de posição da pergunta dependente
      let numeroDependente = 0

      //  percorre as opções e seta as mesmas, verifica se tem dependente e repete este processo
      pergunta.opcoes_perguntas_dependentes.forEach((opcaoDependente) => {
        array[posicao].opcoes.push({
          id: opcaoDependente.id,
          resposta: opcaoDependente.resposta,
          possuiDependente: opcaoDependente.perguntas_dependentes.length > 0,
          finaliza_questionario: opcaoDependente.finaliza_questionario
        })

        opcaoDependente.perguntas_dependentes.forEach((perguntaDependente) => {
          numeroDependente += 1
          this.setPergunta(perguntaDependente, array, numeroDependente, true, posicao, numeroAtual, opcaoDependente.id)
        })
      })

      //  por conta de possuir dependentes da propria pergunta percorre os mesmos e repete este processo
      pergunta.perguntas_dependentes.forEach((perguntaDependente) => {
        numeroDependente += 1
        this.setPergunta(perguntaDependente, array, numeroDependente, true, posicao, numeroAtual)
      })
    },
    preSalvar () {
      // valida novamente por questão de segurança e garantir o funcionamento o status do questionario
      if (this.status == 'respondido') {
        this.$store.dispatch('setMensagemQuestionario', 'Você já respondeu este formulário!', 'respondido')
        this.$router.push('/mensagem')
      }

      if (this.status == 'suspenso') {
        this.$store.dispatch('setMensagemQuestionario', 'Este formulário não está mais disponível para preenchimento!', 'suspenso')
        this.$router.push('/mensagem')
      }

      this.salvar()
    },
    salvar () {
      let dados = this.$v

      let data = {
        id: this.reenviado ? this.resposta.id : null,
        questionario_id: this.questionario.id,
        nome_organizacao: dados.responsavelOrganizacao.$model,
        nome_responsavel: dados.responsavel.$model,
        cpf_responsavel: dados.responsavelCpf.$model,
        localizacao: this.localizacao,
        secoes: this.secoesQuestionario,
        questionario_enviado_id: this.envio.id,
        lat: this.coordenadas.lat && this.coordenadas.lat != [] ? this.coordenadas.lat : null,
        lon: this.coordenadas.lon && this.coordenadas.lon != [] ? this.coordenadas.lon : null,
        endereco: this.endereco && this.endereco != [] ? this.endereco : null
      }

      this.loading = true

      Vue.http.post('api/questionario/responder', data).then(response => {
        if (response.body.success) {
          if (this.$route.params.token) {
            if (this.sistema.redirect_preencher && this.sistema.url_redirect_preencer) {
              window.location.href = this.sistema.url_redirect_preencer
            }

            let uri = window.location.search.substring(1)
            let params = new URLSearchParams(uri)

            let url_retorno = params.get("url")

            if (url_retorno) {
              window.location.href = url_retorno
            }

            if (this.sistema.servico_complementacao_refresh) {
              let id = data.questionario_enviado_id
              Vue.http.get('api/integrador/questionarios/resposta/edicao/' + id).then(response => {
                if (response.body.success) {
                  let token = response.body.data.token
                  window.location.href = process.env.URL_FRONT + '/responder/' + token
                }
              }).catch(e => {
                console.log('Servidor está fora! ' + e)
              })
            }
          }
          this.$store.dispatch('setMensagemQuestionario', 'Obrigado por responder o formulário. Suas respostas foram enviadas com sucesso! Número do Registro: ' + response.body.data[0], 'sucesso')
          this.$router.push('/mensagem')
        }

        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
        this.loading = false
      })
    },
    finalizarQuestionario (value) {
      let final = false
      let secoes = []

      this.secoesQuestionario.every(function (element, index) {
        let perguntas = []

        element.pergunta.every(function (item, index) {
          perguntas.push(item)

          if (item.id == value) {
            final = true
          }
          if (final) return false
          else return true
        })

        secoes.push({
          titulo: element.titulo,
          ordem: element.ordem,
          pergunta: perguntas
        })

        if (final) return false
        else return true
      })

      this.secoesQuestionario = secoes
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.preSalvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.carregando > 0) {
        this.$bvToast.toast('Há arquivos sendo carregados. Interrompa essas cargas ou aguarde sua conclusão antes de enviar a resposta.', {
          title: 'Erro',
          autoHideDelay: 10000,
          appendToast: true,
          variant: 'danger'
        })
      } else {
        this.salvarForm = true
        if (this.validate()) {
          if (this.sistema.servico_complementacao_refresh) {
            this.preSalvar()
          } else {
            this.confirmar()
          }
        }
      }
    },
    chkState (val) {
      if (!this.visualizar) {
        const field = this.$v[val]
        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    chkStateCPF () {
      if (!this.visualizar) {
        if (!this.salvarForm) {
          return null
        }

        if (this.$v.responsavelCpf.$model.length != 14) {
          return false
        }

        return true
      }
    },
    findFirstError (component = this) {
      if (component.state == false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid && this.validatePerguntas()
    },
    validatePerguntas () {
      let result = true

      this.secoesQuestionario.forEach(secoes => {
        secoes.pergunta.forEach(pergunta => {
          if (pergunta.required &&
              pergunta.exibe &&
              !pergunta.resposta.respostaOp &&
              !pergunta.resposta.respostaTexto &&
              !pergunta.resposta.respostaUpload) {
            result = false
          }
        })
      })

      return result
    },
    voltar () {
      var url_retorno = null

      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)

      url_retorno = params.get("url")

      if (this.sistemaIntegracao.redirect_cadastro && !url_retorno) {
        window.location.href = this.sistemaIntegracao.url_cliente
      }

      if (this.visualizar && !url_retorno) {
        return this.$router.push('/formulario/respostas/' + this.resposta.envio.questionario_id)
      }

      if (this.visualizarQuestionario && !url_retorno) {
        return this.$router.push('/formularios')
      }

      if (url_retorno) {
        window.location.href = url_retorno
      }
    },
    buscaUsuarioIntegracao (user_id) {
      Vue.http.get('api/usuario/' + user_id).then(response => {
        this.usuarioIntegracao = response.data.data[0]
        if (this.usuarioIntegracao.sistema_cliente_id) {
          Vue.http.get('api/sistema/' + this.usuarioIntegracao.sistema_cliente_id).then(response => {
            this.sistemaIntegracao = response.data.data[0]
          })
        }
      })
    },
    getUM (evt) {
      if (!this.$store.state.estado.estados.length && !this.$store.state.cidade.cidades.length && !this.evtFired) {
        this.evtFired = 1
        this.$store.dispatch('getEstados')
        this.$store.dispatch('getCidades')
      }
    }
  }
}
</script>

<style scoped>
.sistema-nome {
    text-align: right;
}

.secao-head {
  background-color: lightgrey;
  font-weight: bold;
  font-size: 18px;
}

#map {
  height: 500px;
  width: 100%;
}

.titulo {
    text-align: center;
}
</style>

<style>
.editor {
    width: 100%;
    height: 80%;
}

.bold {
    font-weight: bold;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>



// WEBPACK FOOTER //
// src/pages/site/externa/ResponderQuestionarios.vue